<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->
  <div class="wccard mb-1  talenpool-sticky-header" >
    <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
        <a data-testid="auto-app-talnepool-candidate-tabs-a-1" class="nav-link" routerLinkActive="active"  routerLink="talentpool">
          My Talent pools({{ myTalentpoolCounts }})
        </a>
        <a data-testid="auto-app-talnepool-candidate-tabs-a-2" class="nav-link" routerLinkActive="active"  routerLink="shared-talentpool">
          Shared Talent pools({{ sharedTalentpoolCounts }})
        </a>
        <a data-testid="auto-app-talnepool-candidate-tabs-a-3" class="nav-link" routerLinkActive="active"  routerLink="candidate-list">
          All Candidates({{ allCandidateCounts }})
        </a>
    </ul>
</div>

<div class="tab-content">
  <div class="tab-pane fade show active">
      <router-outlet></router-outlet>
  </div>
</div>
